<template>
  <div class="exclude-product-box">
    <div class="trigger-box">
      <span class="selectNumBox">
        已选择<span class="num">{{
          form[fieldKey] ? form[fieldKey].length : 0
        }}</span
        >个
      </span>
      <bi-button type="blueText" :disabled="initLoading" @click="handleClick"
        >选择标签</bi-button
      >
    </div>

    <!-- <exclude-product-dialog
      :showModal.sync="dialogVisible"
      :value="form[fieldKey] || []"
      :checked.sync="checked"
      :tagList="tagList"
      @confirm="handleConfirm"
      @cancel="handleCancel"
      @initExclude="initExclude"
    ></exclude-product-dialog> -->
    <TagSelectDialog
      :showModal.sync="dialogVisible"
      :value="form[fieldKey] || []"
      :checked.sync="checked"
      :tagList="tagList"
      @confirm="handleConfirm"
      @cancel="handleCancel"
      @initExclude="initExclude"
      :initLoading="initLoading"
    />
  </div>
</template>

<script>
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";
import ExcludeProductDialog from "./excludeProductDialog.vue";
import {
  querySectionConfig,
  saveSectionConfig,
  queryTagList,
} from "@/api/bi/reviewReport/sectionConfig.js";
import TagSelectDialog from "./TagSelectDialog.vue";
export default {
  name: "ExcludeProductCom",
  components: {
    ExcludeProductDialog,
    TagSelectDialog,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    placeholder: {
      type: String,
      default: "请选择排除商品",
    },
    fieldKey: {
      type: String,
      default: "excludeItemTagIdList",
    },
    nowShopList: {
      type: Array,
      default: () => [],
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    // 是否查询了上一次的配置
    initFormData: {
      type: Boolean,
      default: false,
    },
    isFormInit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      checked: true,
      originalChecked: true,
      initLoading: true,
      form: {},
      originalData: [],
      tagList: [],
      isInit: false,
    };
  },
  async mounted() {
    // 初始化
    if(!this.isFormInit) {
    this.isInit = true;
    await this.querySectionConfigFn();
    this.$emit("initProduct", "product");
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (!isEqual(newVal, this.form)) {
          this.form = cloneDeep(newVal || {});
          if(this.form.excludeItemTagIdList && this.form.excludeItemTagIdList.length > 0) {
            this.form.excludeItemTagIdList = this.form.excludeItemTagIdList.map((item) => item.toString());
          }
          if (!this.form[this.fieldKey]) {
            this.$set(this.form, this.fieldKey, []);
          }
        }
      },
      immediate: true,
      deep: true,
    },
    form: {
      handler(newVal) {
        this.$emit("input", cloneDeep(newVal));
        // this.$emit("input", {
        //   ...this.value,
        //   excludeItemTagIdList: cloneDeep(newVal.excludeItemTagIdList || [])
        // });
      },
      deep: true,
    },
    'value.platformSellerIds': {
      handler(newVal, oldVal) {
        if (newVal && newVal.length > 0 && !isEqual(newVal, oldVal) && this.isInit) {
          this.querySectionConfigFn();
        }
      },
      immediate: true
    },
    initFormData: {
      async handler(val) {
        if(val) {
           // 初始化
          this.isInit = true;
          await this.querySectionConfigFn();
          this.$emit("initProduct", "product");
        }
      },
      immediate: true
    },
  },
  methods: {
    initExclude(val) {
      if(val) {
      this.$emit("initProduct", val);
      }else{
        this.querySectionConfigFn();
      }
    },
    async querySectionConfigFn() {
      
      this.initLoading = true;
      try {
        let params = {
          platformCompanySellerIdStr: Array.isArray(this.value.platformSellerIds) && this.value.platformSellerIds.length > 0 ? this.value.platformSellerIds[0] || "" : this.value.platformSellerIds || "",
        }
        if(this.isMultiple) {
          let id = Array.isArray(this.value.platformSellerIds) && this.value.platformSellerIds.length > 0 ? this.value.platformSellerIds.join(',') || "" : this.value.platformSellerIds || "";
          if(!id){
            id = this.nowShopList.join(',') || "";
          }
          params = {
            platformCompanySellerIdStr: id
          }
        }
        const [tagListRes, configRes] = await Promise.all([
          queryTagList(params),
          querySectionConfig({ type: 21 }),
        ]);
        this.initLoading = false;
        if (configRes.code === 200 || configRes.code === 1) {
          const data = configRes.data ? JSON.parse(configRes.data) : [];
          this.tagList = tagListRes.data || [];
          let realData = [];
          const allValidIds = [];
          this.tagList.forEach((item) => {
            if (item.itemTagList) {
              item.itemTagList.forEach((tag) => {
                allValidIds.push(String(tag.id));
              });
            }
          });
          this.$emit("isHasData", this.tagList.length >0 ? 1 : 2);
          // 过滤出有效ID
          if(!this.isFormInit){
            realData = data.filter((id) => allValidIds.includes(String(id)));
            if(realData && realData.length > 0){
              this.$set(this.form, this.fieldKey, realData);
            }
          }else{
            if(this.form.firstForm) {
              realData = data.filter((id) => allValidIds.includes(String(id)));
              this.$set(this.form, this.fieldKey, realData);
              this.$set(this.form, 'firstForm', false);
            }else{
              let nowData = cloneDeep(this.form[this.fieldKey]);
              nowData = nowData.filter((id) => allValidIds.includes(String(id)));
              this.$set(this.form, this.fieldKey, nowData);
              realData = [];
            }
          }
          this.originalData = cloneDeep(realData);
          // 有数据则默认勾选"应用于全局"
          this.checked = realData.length > 0;
          this.originalChecked = this.checked;
        }
      } catch (error) {
        this.initLoading = false;
        console.error("Failed to fetch section config:", error);
      }
    },
    async reset() {
      if (this.originalData) {
        this.$set(this.form, this.fieldKey, cloneDeep(this.originalData));
        this.checked = this.originalData.length > 0;
        this.originalChecked = this.checked;
      } else {
        await this.querySectionConfigFn();
      }
    },
    handleClick() {
      this.dialogVisible = true;
      this.$emit("click");
    },
    async handleConfirm(selectedIds) {
      this.$set(this.form, this.fieldKey, cloneDeep(selectedIds));
      this.originalChecked = this.checked;
      if (this.checked) {
        const params = {
          type: 21,
          data: JSON.stringify(this.form[this.fieldKey]),
        };
        try {
          const res = await saveSectionConfig(params);
          if (res.code === 200 || res.code === 1) {
            this.$message.success("保存成功");
            this.originalData = cloneDeep(this.form[this.fieldKey]);
          } else {
            this.$message.error(res.message || "保存失败");
          }
        } catch (error) {
          console.error(error);
          this.$message.error("保存失败");
        }
      }
    },
    handleCancel() {
      this.checked = this.originalChecked;
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.exclude-product-box {
  width: 300px;
  .trigger-box {
    height: 30px;
    line-height: 30px;
    padding: 0 4px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    width: 300px;
    background: #fff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdee1;

    &:hover,
    &.is-active {
      border-color: #3159ff;
    }
    .trigger-text {
      font-size: 14px;
      color: #606266;
      width: 234px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .selectNumBox {
      background: #f5f5f5;
      border-radius: 2px 2px 2px 2px;
      height: 22px;
      line-height: 22px;
      padding: 0 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      margin-right: 8px;
      .num {
        color: #ff7f23;
        padding: 0 2px;
      }
    }
  }
}
</style>
